import React from "react";

export default function GeneralLocalization() {
  return (
    <div className="bg-darkBlue font-secondary py-8">
      <div className="main flex w-6/12 text-white mx-auto justify-center">
        <div className="left pr-6 text-3xl font-bold">
          <h1>
            The General Localization{" "}
            <span className="text-orange">Process</span>
          </h1>
        </div>
        <div className="right pl-6 text-xl font-bold">
          <ul>
            <li>
              <img src="" alt="" />
              <h1 className="pb-8">UI/content extraction</h1>
              <div className="border-b bg-gray block w-475px"></div>
            </li>{" "}
            <li>
              <img src="" alt="" />
              <h1 className="py-8">Project Management</h1>
              <div className="border-b bg-gray block w-475px"></div>
            </li>{" "}
            <li>
              <img src="" alt="" />
              <h1 className="py-8">Content Localization</h1>
              <div className="border-b bg-gray block w-475px"></div>
            </li>{" "}
            <li>
              <img src="" alt="" />
              <h1 className="py-8">Re-design</h1>
              <div className="border-b bg-gray block w-475px"></div>
            </li>{" "}
            <li>
              <img src="" alt="" />
              <h1 className="py-8">LQA</h1>
              <div className="border-b bg-gray block w-475px"></div>
            </li>{" "}
            <li>
              <img src="" alt="" />
              <h1 className="py-8">VQA</h1>
              <div className="border-b bg-gray block w-475px"></div>
            </li>{" "}
            <li>
              <img src="" alt="" />
              <h1 className="py-8">Reformatting</h1>
              <div className="border-b bg-gray block w-475px"></div>
            </li>
            <li>
              <img src="" alt="" />
              <h1 className="py-8">Content Reintegration</h1>
              <div className="border-b bg-gray block w-475px"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
